/**
 * Sprint 3b — 6 Mrt 2026
 * Gedeelde currency-configuratie voor de hele applicatie.
 *
 * ANG is verwijderd uit `SUPPORTED_CURRENCIES` (mag niet meer als NIEUWE keuze
 * worden aangeboden). Oude records met `ANG` moeten leesbaar blijven: gebruik
 * daarom `normalizeCurrency()` bij het weergeven en `SUPPORTED_CURRENCIES` bij
 * <select>-lijsten. Backend Pydantic regex accepteert ANG nog voor
 * backwards-compat op read/patch.
 */

// Volgorde bewust: EUR default, XCG (Curaçao/Sint Maarten) direct daarna,
// gevolgd door USD en de rest van Caribbean/international.
export const SUPPORTED_CURRENCIES = [
  "EUR",
  "XCG",
  "USD",
  "AWG",
  "SRD",
  "JMD",
  "COP",
  "DOP",
  "GYD",
  "PAB",
  "GBP",
  "CHF",
  "CAD",
  "AUD",
];

export const DEFAULT_CURRENCY = "EUR";

// Human labels voor UI (optioneel gebruikt in tooltips/legenda).
export const CURRENCY_LABELS = {
  EUR: "Euro",
  XCG: "Caribbean guilder",
  USD: "US dollar",
  AWG: "Aruban florin",
  SRD: "Surinaamse dollar",
  JMD: "Jamaican dollar",
  COP: "Colombian peso",
  DOP: "Dominican peso",
  GYD: "Guyanese dollar",
  PAB: "Panamanian balboa",
  GBP: "British pound",
  CHF: "Swiss franc",
  CAD: "Canadian dollar",
  AUD: "Australian dollar",
  // Legacy — alleen voor read/display
  ANG: "Nederlands-Antilliaanse gulden (legacy)",
};

/**
 * Normaliseer een currency-string voor weergave. Onbekende waarden vallen
 * terug op EUR om broken chips/labels te vermijden. Legacy ANG blijft ANG
 * (backwards compat).
 */
export function normalizeCurrency(value) {
  const c = String(value || "").toUpperCase().trim();
  if (!c) return DEFAULT_CURRENCY;
  if (SUPPORTED_CURRENCIES.includes(c) || c === "ANG") return c;
  return DEFAULT_CURRENCY;
}
